export default __webpack_public_path__ + "static/media/perk-rare.06794125.png";